import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { TotalDepositsComponent } from './total-deposits.component';
import { DateTimestampFormatPipe } from 'src/app/pipes/date-timestamp-format.pipe';


@NgModule({
  declarations: [
    TotalDepositsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    DateTimestampFormatPipe,
  ]
})
export class TotalDepositsModule { }
